import { post, get_projectory } from '../tools/http';

const api = {
    startTest: (testId, singleResult, returnUrl = null) => {
        let type = 'test';
        if (returnUrl) {
            return post(
                'examination',
                `sessions/${type}/${testId}/start?single_result=${singleResult}`,
                { "returnUrl": returnUrl },
                true
            );
        } else {
            return post(
                'examination',
                `sessions/${type}/${testId}/start?single_result=${singleResult}`,
                {},
                true
            );
        }
    },
};

export default {
    state: {
        tests: [],
        projectory_achieved_tests: [],
        projectory_current_test: {},
        sessions: [],
    },
    mutations: {
        writeTests: (state, items) => {
            state.tests = items.reduce((acc, test) => {
                acc[test.id] = test;
                return acc;
            }, {});
        },
        writeSessions: (state, items) => {
            state.sessions = items || [];
        },
        writeProjectoryAchivedTest: (state, test) => state.projectory_current_test = test,
        writeProjectoryAchivedTests: (state, tests) => state.projectory_achieved_tests = tests,
    },
    actions: {
        loadProjectoryAchivedTests: async ctx => {
            ctx.commit('writeProjectoryAchivedTests', []);
            let tests = await get_projectory('achieved', true);
            ctx.commit('writeProjectoryAchivedTests', tests);
        },
        loadProjectoryAchivedTest: async (ctx, id) => {
            ctx.commit('writeProjectoryAchivedTest', {});
            let test = await get_projectory(`${id}/results`, true);
            ctx.commit('writeProjectoryAchivedTest', test);
        },
        startTest: async (ctx, { testId, singleResult, returnUrl }) => {
            const res = await api.startTest(testId, singleResult, returnUrl);
            if (!res) {
                return null;
            }
            const url = res.redirectUrl;
            return url;
        },
    },
    getters: {
        recommendedTests: state => [],
        testsCompleted: state => Object.values(state.sessions.reduce((acc, session) => {
            if (['completed', 'in_check'].indexOf(session.status) > -1
                && state.tests[session.test_id]) {
                session.start_date = new Date(session.start_time);
                session.end_date = new Date(session.end_time);

                if (!acc[session.test_id]) {
                    acc[session.test_id] = {
                        ...state.tests[session.test_id],
                        session,
                    };
                } else {
                    if (acc[session.test_id].session.end_date < session.end_date) {
                        acc[session.test_id].session = session;
                    }
                }
            }
            return acc;
        }, {})).sort((a, b) => b.session.end_date - a.session.end_date),
        testsInProgress: state => Object.values(state.sessions.reduce((acc, session) => {

            if (session.status == 'in_progress'
                && state.tests[session.test_id]) {
                session.start_date = new Date(session.start_time);

                let currentSession = acc[session.test_id]
                    ? acc[session.test_id].session
                    : null;

                if (!currentSession) {
                    acc[session.test_id] = {
                        ...state.tests[session.test_id],
                        session,
                    };
                } else if (currentSession.start_date < session.start_date) {
                    acc[session.test_id].session = session;
                }
            }

            return acc;
        }, {})).sort((a, b) => b.session.start_date - a.session.start_date),
        // myTests: state => state.sessions.map((session) => ({
        //     ...state.tests[session.test_id],
        //     session,
        // })),
        projectory_current_test: state => state.projectory_current_test,
        projectory_achived_tests: state => state.projectory_achieved_tests,
    },
};
